var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInteract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 345.04 346.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-2);}.cls-10,.cls-2{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{isolation:isolate;}.cls-4{mask:url(#mask-2);}.cls-5{fill:#3457a6;}.cls-10,.cls-6{fill:#f58622;}.cls-7{fill:#f7cc31;}.cls-8{fill:#2385c6;}.cls-9{fill:none;stroke:#f7cc31;stroke-linecap:round;stroke-linejoin:round;stroke-width:7px;}.cls-11,.cls-12{fill:#fff;}.cls-11{opacity:0.5;}.cls-13{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 20.71,
    y: -11274.57,
    width: 27.09,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 20.71,
    y: -11274.57,
    width: 27.09,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 43.43,
    y1: 210.86,
    x2: 68.37,
    y2: 210.86,
    gradientTransform: "matrix(1, -0.06, 0.06, 1, -33.23, -32.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 20.71,
    y: 146.68,
    width: 27.09,
    height: 57.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 20.71,
    y: 146.68,
    width: 27.09,
    height: 57.51,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40,203.7l-8.35.47a8.31,8.31,0,0,1-8.71-7.91L20.73,156a8.34,8.34,0,0,1,7.8-8.85l8.35-.47a8.31,8.31,0,0,1,8.71,7.92l2.2,40.25A8.35,8.35,0,0,1,40,203.7Z"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pixelcities_elements") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40,203.7l-8.35.47a8.31,8.31,0,0,1-8.71-7.91L20.73,156a8.34,8.34,0,0,1,7.8-8.85l8.35-.47a8.31,8.31,0,0,1,8.71,7.92l2.2,40.25A8.35,8.35,0,0,1,40,203.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.6,200.8l-47.77,2.69a8.33,8.33,0,0,1-8.72-7.92l-2.2-40.25a8.36,8.36,0,0,1,7.8-8.85l47.77-2.69a8.32,8.32,0,0,1,8.72,7.92L99.4,192A8.36,8.36,0,0,1,91.6,200.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.18,200.6l-47.77,2.68a8.3,8.3,0,0,1-8.71-7.91l-2.2-40.25a8.35,8.35,0,0,1,7.8-8.85l47.77-2.69a8.32,8.32,0,0,1,8.71,7.92l2.2,40.25A8.35,8.35,0,0,1,95.18,200.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 69.8,
    cy: 173.52,
    rx: 18.64,
    ry: 18.39,
    transform: "translate(-104.13 242.3) rotate(-89.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.79,154.91c-.47,0-.92.07-1.38.13a18.66,18.66,0,0,1,2,37.11c.46,0,.92,0,1.38,0a18.64,18.64,0,0,0-2-37.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.49,173.93a2.81,2.81,0,1,1-3-2.69A2.84,2.84,0,0,1,62.49,173.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.68,173a2.81,2.81,0,1,1-3-2.69A2.84,2.84,0,0,1,79.68,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.52,171.24a3,3,0,0,0-.52.08,2.86,2.86,0,0,1,.31,5.6,3.09,3.09,0,0,0,.53,0,2.85,2.85,0,0,0-.32-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.71,170.27a2.27,2.27,0,0,0-.52.09A2.83,2.83,0,0,1,78.63,173,2.86,2.86,0,0,1,76.5,176a3,3,0,0,0,.52,0,2.85,2.85,0,0,0-.31-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M150.63,157.16c10.55-1.67,22.23-2.48,31.05,3.54,6.72,4.59,10.61,12.66,11.14,20.78s-2,16.22-6.14,23.25c-2.66,4.55-6.1,8.83-10.72,11.38s-10.59,3.1-15.13.4-6.87-9-4.27-13.65c3-5.38,10.74-6.05,16.54-4a26.2,26.2,0,0,1,11.84,40.62c-7.62,9.9-20.87,13-32.61,17.25S128,269.14,127.16,281.61c-.54,8.07,4.39,15.8,11,20.45s14.74,6.68,22.74,7.91c10.36,1.58,21.56,1.83,30.63-3.4,8.72-5,14.09-14.25,21.76-20.76,7.84-6.65,17.86-10.23,27.93-12.29a112.5,112.5,0,0,1,57,3.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.27,167.51c1.65-.26,3.09.28,3.23,1.2s-1.09,1.87-2.74,2.12-3.08-.29-3.22-1.2S134.63,167.76,136.27,167.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M114.26,165.29a2.86,2.86,0,0,0-2.21,3.36,2.82,2.82,0,0,0,3.32,2.24l18.4-3.76-1.1-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M117.71,157.07a2.85,2.85,0,0,0-2.21,3.36,2.82,2.82,0,0,0,3.32,2.23l14.65-3-1.11-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M130.11,167.88l3.66-.75-1.1-5.59-3.79.77C129.27,164.27,129.68,166.14,130.11,167.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.56,160.67l4.56-.93c-.41-2-.84-3.83-1.27-5.56l-4.23.87C127.88,156.81,128.19,158.7,128.56,160.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.64,151.49,152,153a2.36,2.36,0,0,1-1.86-.38l-13.69-9.55a5.1,5.1,0,0,0-3.94-.82L129,143c-1.26.26-.67,8.65,1.33,18.74s4.64,18.07,5.9,17.81l3.54-.72a5.19,5.19,0,0,0,3.33-2.3l9-14.17a2.45,2.45,0,0,1,1.57-1.09l7.61-1.55a1.14,1.14,0,0,0,.89-1.36l-1.18-6A1.14,1.14,0,0,0,159.64,151.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M217.8,143l-19-83.77S237,78.07,246.3,119s-7.62,63.31-7.62,63.31l-13.11,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M230.08,129l44.25-73.3S288.6,96.33,267,132.13s-49.15,39.75-49.15,39.75l-11.47-7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.15,137.9l77-35.89s-10.45,41.82-48,59.35-62.64,5.24-62.64,5.24l-5.61-12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.32,146.17,328,148.55s-27.61,32.82-69,31.65-58.46-23.42-58.46-23.42l.37-13.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M243.25,176.79l30.08,38.78s-53.11,1.08-68.69-29.74-16.5-50.4-32.79-46.59l-33,8.59a.5.5,0,0,1-.29-1l45.63-18s15.38-6.19,23.53,1.74S243.25,176.79,243.25,176.79Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteract);
export default __webpack_public_path__ + "static/media/interact.2d5878fada95de8fa7bc0531310aac74.svg";
export { ForwardRef as ReactComponent };